//To use this, put this in your HTML:
//  <donor-picker #modalDonorPicker></donor-picker>
//Then put this in your TS file:
//  @ViewChild('modalDonorPicker') modalDonorPicker;
//Then show it by calling this and passing the callback funtions into show():
//  this.modalDonorPicker.show()
//
import { Component, OnInit, ViewEncapsulation, ViewChild } from '@angular/core';
import { GridOptions } from 'ag-grid-community';
import { WebService, Donor, ApiResponse } from '../../shared/web-service/web.service';
import { GridFooterComponent } from '../grid-footer/grid-footer.component';

@Component({
  selector: 'donor-picker',
  templateUrl: './donor-picker.component.html',
  styleUrls: ['./donor-picker.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DonorPickerComponent implements OnInit {
  @ViewChild('modalPicker') modalPicker;

  callbackSave: Function;
  callbackAddDonor: Function;
  callbackRemoveJointDonor: Function;
  dontIncludeThisDonorNoInList;
  rowDataGrid: Donor[] = [];
  donorOptions: Donor[]; //This is the list of donors from the server. We later put some of the donors from this list into rowDataGrid to display to the user.
  gridOptions: GridOptions;
  msgBox: any;
  pickingJointDonor: boolean;
  enableDonorEnvelope: boolean = JSON.parse(sessionStorage.enableDonorEnvelope);
  gridFilter = {
    name: '' as string,
    envelope: '' as string,
  };
  static staticInstance: DonorPickerComponent;

  constructor(private webService: WebService) {
    this.gridOptions = <GridOptions>{
      pagination: true,
      suppressCellSelection: true,
      suppressDragLeaveHidesColumns : true,
      suppressRowClickSelection: true,
      suppressColumnVirtualisation: true, //This makes it resize the columns correctly at page load (even the ones not shown yet because of scrolling)
      defaultColDef: { sortable: true, filter: true, resizable: true },
      columnDefs: [
        { headerName: 'Actions', field: 'pledgeNo', suppressMenu: true, sortable: false, cellRenderer: this.actionCellRendererFunc },
        { headerName: 'First name', field: 'firstName', suppressMenu: true },
        { headerName: 'Last name', field: 'lastName', suppressMenu: true },
        { headerName: 'Envelope', field: 'envelope', suppressMenu: true },
      ],
      onFirstDataRendered: (params) => {
        GridFooterComponent.sizeColumnWidths(null, "gridDonors", this.gridOptions, "Donor_Picker");
      }
    };
    //Remove the Envelope column if this NP doesn't use envelope numbers.
    if (!this.enableDonorEnvelope) {
      for (let i = 0; i < this.gridOptions.columnDefs.length; i++) {
        if (this.gridOptions.columnDefs[i].headerName == "Envelope") {
          this.gridOptions.columnDefs.splice(i, 1);
          break;
        }
      }
    }
  }

  ngOnInit() {
    DonorPickerComponent.staticInstance = this;
    $("#donorModalPicker .modal-dialog").css("maxWidth", "550px"); //By default the dialogs in this system are 500px wide, but we need ours to be wider.
    //I figured out a different way to do this, so we don't need the statement below. I'll leave it here in case we need to do this in the future. The thing that determins the z-order (if all the dialogs have the default value) is the order in which they are declared in the HTLM (e.g. <donor-add-edit> before <donor-picker>).
    //$("#donorModalPicker .basic.modal").css("z-index", "9999"); //The thing that defines which dialog is on top is a div that has the class basic.modal. By default it has a z-index of 1050. This will put this dialog on top of the others.
  }

  //This funtion returns either an HTML string or object that is the HTML for the cell. 
  //passed in: params.data is the object that is the data source for the row.
  actionCellRendererFunc(params) {
    var span = document.createElement('span');

    var link = document.createElement('a');
    link.innerHTML = 'Select';
    link.setAttribute('href', 'javascript:void(0);');
    link.addEventListener('click', () => {
      DonorPickerComponent.staticInstance.finishChangeDonor(params.data);
    });
    span.appendChild(link);

    return span;
  }

  //We remember the list of donors so we don't have to get it every time the dialog appears. However, you can use this function (passing in null) to forget the list, so that it is retrieved again from the server. You should do this, for example, if the NP changes that the UI is working on.
  setDonorsList(newList: Donor[]) {
    this.donorOptions = newList;
  }

  //This will show the donors dialog. Pass into it a function that will be called when the users chooses a donor. The callback funtion must take two parameters: the first is the donorNo and the second is the donorName of the new selected donor. The second param passed into this function is a callback function that is called if the user clicks the link to add a new user. If nothing is passed for this, the link to add a new user won't be there.The third param passed into this function is a callback function that is called if the user clicks the link to remove the current joint donor. The fourth parameter is wheter or not we should display the link to remove the joint donor. The fifth param is used if there's a donor that you don't want to show in the list (e.g. this dialog is used to pick a joint donor, so you don't want to show the donor in the list you are picking joint for).
  showDonorPicker(msgBox, callbackSave?: Function, callbackAddDonor?: Function, callbackRemoveJointDonor?: Function, showLinkRemoveJointDonor?: boolean, dontIncludeThisDonorNoInList?: number) {
    this.gridFilter.name = "";
    this.gridFilter.envelope = "";
    this.pickingJointDonor = (dontIncludeThisDonorNoInList != undefined); //If this dialog is for picking a joint donor for another donor, dontIncludeThisDonorNoInList will be passed in. If this dialog is just for picking a donor (e.g. for a contribution), then it will be undefined.
    this.msgBox = msgBox;
    this.callbackSave = callbackSave;
    this.callbackAddDonor = callbackAddDonor;
    this.callbackRemoveJointDonor = (showLinkRemoveJointDonor ? callbackRemoveJointDonor : null);
    this.dontIncludeThisDonorNoInList = dontIncludeThisDonorNoInList;
    //Get the list of donors from the server. We only need to do this once for the duration of the page, so we check if donorOptions has alredy been filled.
    if (this.donorOptions) {
      this.modalPicker.show();
      this.updateDonorsGrid();
      setTimeout(function () { $("#nameInput").focus() }, 300); //set focus on the name input. We have to use setTimeout to set the focus because you can't set focus until it appears, which takes a moment.
    }
    else {
      this.webService.donors_GetAllDonors(true).subscribe(apiResponse => {
        if (ApiResponse.checkStatus(apiResponse)) {
          this.donorOptions = apiResponse.donorList;
          this.updateDonorsGrid();
        }
      });
      this.modalPicker.show();
      setTimeout(function () { $("#nameInput").focus() }, 300); //set focus on the name input. We have to use setTimeout to set the focus because you can't set focus until it appears, which takes a moment.
    }
  }

  //Select a donor by hiding dialog and calling callback function.
  finishChangeDonor(selectedDonor: Donor) {
    const selectedName = selectedDonor.firstName + " " + selectedDonor.lastName;
    //If this dialog is choosing a joint donor: the Check to see if they selected a joint donor that's already assigned. Make exception if the selected joint donor is already assinged to the donor we are editing.
    if (this.pickingJointDonor && selectedDonor.jointDonorNo && selectedDonor.jointDonorNo !== this.dontIncludeThisDonorNoInList)
      this.msgBox.show("Error", selectedName + " is already a joint donor for " + selectedDonor.jointDonorName + ". Please select a different donor, or first edit " + selectedName + " or " + selectedDonor.jointDonorName + " to remove their current joint donor relationship.", false);
    else {
      this.modalPicker.hide();
      if (this.callbackSave)
        this.callbackSave(selectedDonor.donorNo, selectedName, selectedDonor.federalID);
    }
  }

  //Close dialog without doing anything.
  cancelChangeDonor() {
    this.modalPicker.hide();
  }

  addNewDonor() {
    this.callbackAddDonor();
  }

  removeJointDonor() {
    this.modalPicker.hide();
    this.callbackRemoveJointDonor();
  }
  
  hideDonorPicker() {
    this.modalPicker.hide();
  }
  
  //This will fill the donors grid using the filters.
  updateDonorsGrid() {
    this.rowDataGrid.length = 0;
    const nameFilter = this.gridFilter.name.toLowerCase().trim();
    const envelopeFilter = this.gridFilter.envelope.toLowerCase().trim();

    //If nameFilter is just one name, we return any donors with nameFilter located anywhere in either their first or last name.If we find a space in nameFilter, we assume it's a first name and last name, so we split it into two, and return and donors that have a match for the first name and a separate match for the last name.
    let twoNames: boolean = false;
    let firstName: string;
    let lastName: string;
    let space: number = nameFilter.indexOf(' ');
    if (space != -1) {
      twoNames = true;
      firstName = nameFilter.substring(0, space).trim();
      lastName = nameFilter.substring(space).trim();
    }

    for (let i: number = 0; i < this.donorOptions.length; i++) {
      //rowDataGrid has a copy of the objects in donorOptions, except don't put in donors that don't match the filters.
      if (this.donorOptions[i].donorNo != this.dontIncludeThisDonorNoInList &&
        this.donorOptions[i].donorActive &&
        (nameFilter.length === 0 || (!twoNames && (this.donorOptions[i].firstName.toLowerCase().indexOf(nameFilter) !== -1 || this.donorOptions[i].lastName.toLowerCase().indexOf(nameFilter) !== -1)) || (twoNames && this.donorOptions[i].firstName.toLowerCase().indexOf(firstName) !== -1 && this.donorOptions[i].lastName.toLowerCase().indexOf(lastName) !== -1)) &&
        (envelopeFilter.length === 0 || this.donorOptions[i].envelope.toLowerCase().indexOf(envelopeFilter) !== -1)) {
        this.rowDataGrid.push(this.donorOptions[i]);
      }
    }
    this.gridOptions.api.setRowData(this.rowDataGrid);
  }
}
